import React from 'react';
import dayjs from 'dayjs';

export const useDateManagement = ({ startDate, endDate }) => {
  const startDateRef = startDate;
  const endDateRef = endDate;

  const dateChangeAction = {
    startDate: (date) => {
      startDateRef.current = date;
    },
    endDate: (date) => {
      endDateRef.current = date;
    }
  };

  const disabledDateAction = {
    startDate: (current) => {
      const currentDate = dayjs().endOf('day');

      if (endDateRef.current) {
        return (
          current &&
          (current < currentDate ||
            current > dayjs(endDateRef.current).endOf('day').subtract(1, 'day'))
        );
      }

      return current && current < currentDate;
    },
    endDate: (current) => {
      const currentDate = dayjs().endOf('day').add(1, 'day');

      if (startDateRef.current) {
        return (
          current &&
          (current < currentDate ||
            current < dayjs(startDateRef.current).endOf('day'))
        );
      }
      return current && current < currentDate;
    },
    year: (current) => {
      const currentDate = dayjs().endOf('year').subtract(1, 'year');
      return current && current < currentDate;
    },
    month: (current) => {
      const currentDate = dayjs().endOf('month').subtract(1, 'month');
      return current && current < currentDate;
    }
  };

  const cellRenderer = (current, dateType, info) => {
    const isDisabled = disabledDateAction[dateType](current);
    const disabledYears = disabledDateAction.year(current);
    const disabledMonth = disabledDateAction.month(current);

    const disabledObject = {
      date: isDisabled,
      month: disabledMonth,
      year: disabledYears
    };

    if (info.type !== 'date') {
      if (disabledObject[info.type])
        return (
          <div style={{ background: 'rgba(0, 0, 0, 0.04)' }}>
            {info.originNode}
          </div>
        );
      return info.originNode;
    }
    return isDisabled ? (
      <div style={{ background: 'rgba(0, 0, 0, 0.04)' }}>{current.date()}</div>
    ) : (
      current.date()
    );
  };

  return {
    dateChangeAction,
    disabledDateAction,
    cellRenderer
  };
};
